"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroHeader() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="256825" id="hero-header" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40 min-h-[80vh] flex items-center">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: `linear-gradient(to right, var(--secondary) 1px, transparent 1px), linear-gradient(to bottom, var(--secondary) 1px, transparent 1px)`,
      backgroundSize: '48px 48px',
      maskImage: 'radial-gradient(ellipse 80% 80% at 50% 0%, #000 40%, transparent 100%)',
      WebkitMaskImage: 'radial-gradient(ellipse 80% 80% at 50% 0%, #000 40%, transparent 100%)'
    }} />

      <div className="page-container relative z-10">
        <div ref={ref} className={`max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="flex items-center gap-4 mb-8">
            <div className="h-px w-8 bg-secondary"></div>
            <span className="text-xs font-bold tracking-[0.2em] text-secondary uppercase">
              LEGAL
            </span>
          </div>

          {}
          <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-[84px] font-bold tracking-tight text-foreground mb-8 leading-[1.05]">
            Terms of Service
          </h1>

          {}
          <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl leading-relaxed">
            Please read these terms carefully before purchasing any service from BlinkLab Media.
          </p>

          {}
          <div className="flex flex-wrap gap-4">
            <div className="flex flex-col gap-2">
              <span className="text-sm text-muted-foreground font-sans">
                Last Updated: October 24, 2023 — A Division of BL Events LLC
              </span>
              <div className="h-px w-full bg-secondary opacity-50 mt-4"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}